import { GenericRootThunkAction } from "../../types/common";
import { IMessage } from "../reducers/messagesReducer";

export const ADD_MESSAGE = "ADD_MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";

export const addMessage = (message: IMessage) => ({ type: ADD_MESSAGE, payload: { message } });

export const removeMessage = (message: IMessage) => ({
  type: REMOVE_MESSAGE,
  payload: { message },
});

export const successMessage = (text: string): GenericRootThunkAction => (dispatch) => {
  dispatch(addMessage({ text, severity: "success" }));
};

export const errorMessage = (text: string): GenericRootThunkAction => (dispatch) => {
  dispatch(addMessage({ text, severity: "error" }));
};
